import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { COUNTIES, EMAIL, PHONE } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#0A192F] text-slate-300 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-slate-400 leading-relaxed">Nurses, carers and clinical teams for hospitals, care homes and families across the East Midlands. Day and night.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-sky-300 mb-5">Explore</p>
          {[["/", "Home"], ["/services", "Services"], ["/about", "About"], ["/contact", "Contact"]].map(([to, l]) => (
            <Link key={to} to={to} data-testid={`footer-link-${l.toLowerCase()}`} className="block py-1.5 hover:text-white transition-colors">{l}</Link>
          ))}
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow text-sky-300 mb-5">24/7 line</p>
          <p data-testid="footer-phone" className="text-2xl font-bold text-white">{PHONE}</p>
          <p data-testid="footer-email" className="mt-2 text-slate-400">{EMAIL}</p>
          <p className="mt-6 text-sm text-slate-400">{COUNTIES.join(" · ")}</p>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 font-extrabold tracking-tighter leading-[0.8] text-[22vw] md:text-[17vw] text-white/[0.06] select-none -mb-[4vw]">Trentvale</p>
      <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-400">
        <span>© 2026 Trentvale Nursing. [Company number] · [CQC registration]</span>
        <span className="font-mono-x">East Midlands, UK</span>
      </div>
    </div>
  </footer>
);
